import React, { useEffect, useState } from 'react';
import { FixedSizeList as List } from 'react-window';
import { Box, Button, Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText, TextField } from '@mui/material';
import { mapFilterList } from 'utility/constants';
import { disableDoneBtn } from 'utility/helper';

const MyVirtualizedList = ({ items, onItemSelect, filterSelected, subFilterSelection, handleFilterSelection, filterLabel }: any) => {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredItems = items.filter((item: any) =>
    item.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    setSearchTerm('')
  },[items])

  const searchLabel: any = mapFilterList?.filter((item: any) => item?.value === filterSelected)[0];
  const Row = ({ index, style }: any) => (
    <ListItem style={style} >
      <ListItemButton onClick={() => onItemSelect(filteredItems[index], searchLabel?.label)} dense>
        <ListItemIcon
          style={{ minWidth: "auto" }}
        >
          <Checkbox
            edge="start"
            checked={subFilterSelection && subFilterSelection[searchLabel?.label] && subFilterSelection[searchLabel?.label]?.includes(filteredItems[index])}
            tabIndex={-1}
            disableRipple
            inputProps={{ 'aria-labelledby': filteredItems[index] }}
          />
        </ListItemIcon>
        <ListItemText primary={filteredItems[index]} />
      </ListItemButton>
    </ListItem>
  );
  return (
    <div>
      <TextField
        label={`Search ${searchLabel?.label}`}
        variant="outlined"
        fullWidth
        margin="normal"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e?.target?.value)}
      />
      <List
        height={150}
        itemCount={filteredItems?.length}
        itemSize={35}
        width={'100%'}
      >
        {Row}
      </List>
      <Box
        sx={{
          position: 'sticky',
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: 'white', // Match input background
          padding: '8px',
          boxShadow: '0 -1px 5px rgba(0,0,0,0.2)', // Optional shadow
          zIndex: 1,
        }}
        onClick={() => handleFilterSelection()}
      >
        <Button
          onMouseDown={() => handleFilterSelection()}
          variant="contained"
          fullWidth
          disabled={disableDoneBtn(subFilterSelection, filterLabel)}
        >
          Done
        </Button>
      </Box>
    </div>
  );
};

export default MyVirtualizedList;

